<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      requestType: 'GET',
    };
  },
  mounted() {
    this.getConfigList('contract_management_list');
  },
  methods: {
  },
};
</script>
